/* Calendar calculations use date-only UTC values; order day follows Europe/Oslo. */
function sittebrisEaster(year) {
  const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;
  return new Date(Date.UTC(year,Math.floor(n/31)-1,n%31+1));
}
function sittebrisIsWorkday(date) {
  if([0,6].includes(date.getUTCDay())) return false;
  const key=date.toISOString().slice(5,10);
  if(['01-01','05-01','05-17','12-25','12-26'].includes(key)) return false;
  const delta=Math.round((date-sittebrisEaster(date.getUTCFullYear()))/86400000);
  return ![-3,-2,1,39,50].includes(delta);
}
function sittebrisAddWorkdays(date,days) {
  const result=new Date(date);
  for(let added=0;added<days;) {result.setUTCDate(result.getUTCDate()+1);if(sittebrisIsWorkday(result))added++;}
  return result;
}
function sittebrisDeliveryUpdate(now=new Date()) {
  const parts=Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Oslo',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now).map(p=>[p.type,p.value]));
  const today=new Date(Date.UTC(+parts.year,+parts.month-1,+parts.day));
  document.querySelectorAll('[data-delivery-estimate]').forEach(element=>{
    const min=Math.max(1,Math.min(30,Number(element.dataset.minDays )||6));
    const max=Math.max(min,Math.min(30,Number(element.dataset.maxDays)||9));
    const format=new Intl.DateTimeFormat('nb-NO',{timeZone:'UTC',day:'numeric',month:'long'});
    const first=sittebrisAddWorkdays(today,min),last=sittebrisAddWorkdays(today,max);
    const label=element.querySelector('[data-delivery-dates]');
    if(label)label.textContent=format.format(first)+' – '+format.format(last);
  });
}
if(typeof document!=='undefined') {
  sittebrisDeliveryUpdate();
  setInterval(()=>sittebrisDeliveryUpdate(),60000);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)sittebrisDeliveryUpdate();});
  document.addEventListener('shopify:section:load',()=>sittebrisDeliveryUpdate());
}
